<div class="row" [formGroup]="form">
    <div class="col-md-4" style="padding: 15px">
        <mat-label class="font-style">Joint ID - Optional</mat-label>
    </div>
    <div class="col-md-8">
        <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
            <input type="text" matInput placeholder="Joint ID - Optional" formControlName="jointId" name="joint_optional" />
        </mat-form-field>
    </div>
</div>
